// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151105/js/" + chunkId + "." + {"44":"af7d62a3","225":"4a53c776","481":"afa4cf11","486":"642f635d","770":"f82c084b"}[chunkId] + ".0.5286164769306864.chunk.js";
};